/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type NetworkMemberResponseStatus = typeof NetworkMemberResponseStatus[keyof typeof NetworkMemberResponseStatus];


export const NetworkMemberResponseStatus = {
  none: 'none',
  refreshing: 'refreshing',
  ready: 'ready',
} as const;
